import { connect } from 'react-redux';

import { clearEmptyFilterClauses, scrollToActiveElement } from '../../../utils/compound';
import {
  getSelectedFunnel,
  getTenantId,
  getUpdatingFunnel,
  getUpdatingFunnelId,
  isFunnelExists,
} from '../../../reducers/analyticsApp';
import CompoundUpdatePane from '../../../components/compound/update/Pane';
import { cancelUpdateFunnel, createFunnel, updateFunnel } from '../../../actions/funnel';

const mapStateToProps = (state) => {
  const item = getUpdatingFunnel(state);

  return {
    item,
    selectedItem: getSelectedFunnel(state),
    id: getUpdatingFunnelId(state),
    tenantId: getTenantId(state),
    isDisabledSave: !item?.name,
    isExists: (funnel) => isFunnelExists(state, funnel),
    location: 'funnels',
  };
};

const mapDispatchToProps = {
  onCancel: cancelUpdateFunnel,
  create: createFunnel,
  update: updateFunnel,
};

const mergeProps = (stateProps, dispatchProps, ownProps) => ({
  ...ownProps,
  ...stateProps,
  ...dispatchProps,
  onCancel: () => {
    dispatchProps.onCancel();
    const urlId = stateProps.item?.id || stateProps.selectedItem?.id;
    const path = urlId
      ? `/${stateProps.tenantId}/funnels/execution/${urlId}`
      : `/${stateProps.tenantId}/funnels`;
    ownProps.navigate(path);
  },

  onSave: (item, id) => {
    const funnel = clearEmptyFilterClauses(item);
    const onSave = () =>
      stateProps.isExists(funnel) ? dispatchProps.update(funnel, id) : dispatchProps.create(funnel);

    onSave().then((response) => {
      ownProps.navigate(`/${stateProps.tenantId}/funnels/execution/${response.funnel.id}`);
      scrollToActiveElement();
    });
  },
});

// TODO refactoring!!!!
export default connect(mapStateToProps, mapDispatchToProps, mergeProps)(CompoundUpdatePane);
